// created = fields.DateTime('Created')
// requested = fields.DateTime('Requested')
// commanded = fields.DateTime('commanded')
// dispatched = fields.DateTime('Dispatched')
// delivered = fields.DateTime('Delivered')
// rejected = fields.DateTime('Rejected')
// cancelled = fields.DateTime('Cancelled')
function layoutTimes() {
  const ctxView = {
    model: "sale.line",

    form_action: ["create"],
    table_action: ["update"],
    activeSearch: false,
    limit: 50,

    fields: {
      created: {
        type: "datetime",
      },
      requested: {
        type: "datetime",
      },
      commanded: {
        type: "datetime",
      },
      dispatched: {
        type: "datetime",
      },
      delivered: {
        type: "datetime",
      },
    },

    list: [{ name: "created" }, { name: "requested" }, { name: "commanded" }],

    form: [],
  };

  return ctxView;
}

export { layoutTimes };
